// noinspection JSUnusedGlobalSymbols
export default defineNuxtRouteMiddleware((to) => {
  if (!to.fullPath.match(/^\/discord([\/?].*)?$/)) {
    return;
  }
  const config = useRuntimeConfig()
  return navigateTo(config.public.discordUrl, { redirectCode: 301, external: true })
})
